import React from 'react';
import Breadcrumb from '../../components/breadcrumb';
import UQCode from '../../components/code';
import UQSpacer from '../../components/spacer';
import UQDataGrid, { UQDataGridColumn } from '../../components/data-grid';
import { BREADCRUMB_ROOT } from '../../common/config';

const CodePage = () => {
  const attributes = [
    {
      attribute: 'code',
      type: 'string',
      default: 'undefined',
      description: 'The code snippet to display.',
    },
    {
      attribute: 'enableCopy',
      type: 'boolean',
      default: 'false',
      description: 'Enables the copy-to-clipboard functionality.',
    },
    {
      attribute: 'language',
      type: 'string',
      default: 'undefined',
      description: 'The programming language for syntax highlighting.',
    },
    {
      attribute: 'className',
      type: 'string',
      default: "''",
      description: 'Additional class names for custom styling.',
    },
  ];

  const attributeColumns: UQDataGridColumn<typeof attributes[0]>[] = [
    {
      columnId: 'attribute',
      renderHeaderCell: () => 'Attribute',
      renderCell: (item) => item.attribute,
    },
    {
      columnId: 'type',
      renderHeaderCell: () => 'Type',
      renderCell: (item) => <code>{item.type}</code>,
    },
    {
      columnId: 'default',
      renderHeaderCell: () => 'Default',
      renderCell: (item) => <code>{item.default}</code>,
    },
    {
      columnId: 'description',
      renderHeaderCell: () => 'Description',
      renderCell: (item) => item.description,
    },
  ];

  const codeSnippet = `
import React from 'react';
import { UQCode } from '@uniqconsulting/ui';

<UQCode
  code={"<div>Hello, World!</div>"}
  enableCopy
/>
`;

  return (
    <>
      <Breadcrumb crumbs={[BREADCRUMB_ROOT, 'Code']} />
      <h1>UQCode Demo</h1>
      <UQSpacer size="m" />

      {/* Description */}
      <h2>Description</h2>
      <p>
        The <code>UQCode</code> component is used to display code snippets with optional syntax highlighting and copy-to-clipboard functionality. It is ideal for showcasing code examples in documentation or tutorials.
      </p>
      <UQSpacer size="m" />

      {/* Attributes Table */}
      <h2>Attributes</h2>
      <UQSpacer size="s" />
      <UQDataGrid
        items={attributes}
        columns={attributeColumns}
        sortable={false}
        selectionMode="none"
      />
      <UQSpacer size="m" />

      {/* Code Snippet Demo */}
      <h2>Code Snippet Example</h2>
      <UQSpacer size="s" />
      <UQCode code={`<div>Hello, World!</div>`} enableCopy />
      <UQSpacer size="m" />

      {/* Code Example */}
      <h2>Code Example</h2>
      <UQSpacer size="s" />
      <UQCode code={codeSnippet} enableCopy />
    </>
  );
};

export default CodePage;